export default "__VITE_ASSET__c5d8f0ad__"